
  import { defineComponent } from 'vue';
  import { Modal } from '@/ui/components/Modal';
  import { CANNOT_ADD_SEATS_MODAL_WIDTH } from './constants';
  import { Button } from '@/ui/components/Button';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';

  export interface CannotAddUserSeatsModalProps {
    active: boolean;
  }

  export default defineComponent<CannotAddUserSeatsModalProps>({
    components: {
      Modal,
      Button,
      PageSubtitle,
    },
    props: ['active'],
    setup() {
      return {
        email: process.env.VUE_APP_CS_EMAIL,
        CANNOT_ADD_SEATS_MODAL_WIDTH,
      };
    },
  });
